import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Slider from "@material-ui/core/Slider";
import Box from "@material-ui/core/Box";
const FilterSlider = (props) => {

    const [low, setLow] = useState(props.highLow[0])
    const [high, setHigh] = useState(props.highLow[1])

    const handleValueChange = (event, newValue) => {
        setLow(newValue[0]);
        setHigh(newValue[1])
        props.onChange(props.name, newValue);
    };


    return (
        <div className="slidecontainer">
            <Box sx={{ width: 600}}>
                    <Typography style={{marginTop:"20px"}} id="discrete-slider-always">
                        {props.title}
                    </Typography>
                    <Slider
                        className="slider"
                        style={{marginLeft:"144px"}}
                        name={props.name}
                        defaultValue={props.currentValue}
                        value={[low, high]}
                        min={props.min}
                        max={props.max}
                        step={props.step}
                        onChange={handleValueChange}
                        valueLabelDisplay="on"
                        aria-labelledby="range-slider"
                    />
                </Box>
                

        </div>
    );
}

export default FilterSlider;
